import React from 'react'
import ListDisplayTable from '../../components/layout/dataTable/ListDisplayTable'
import { useNavigate } from 'react-router-dom';

const RegistrationFormList = () => {
    const navigate = useNavigate();

    const tableData = [
  {
    id: 1,
    form: "MGT-1",
    register: "Register of Members",
    chapter: "VII",
    section: "S.88(1)(a) & R.3(1) OF COS (MANAGEMENT & ADMINISTRATION) RULES, 2014"
  },
  {
    id: 2,
    form: "MGT-2",
    register: "Register of Debenture Holders / Other Securities Holders",
    chapter: "VII",
    section: "S.88(1)(b) & (c) AND R.4 OF COS (MANAGEMENT & ADMINISTRATION) RULES, 2014"
  },
  {
    id: 3,
    form: "REGISTER",
    register: "Register of Directors and Key Managerial Personnel and Their Shareholding",
    chapter: "XI",
    section: "S.170 & R.17 OF COS (APPOINTMENT & QUALIFICATION OF DIRECTOR) RULES, 2014"
  },
  {
    id: 4,
    form: "SH-2",
    register: "Register of Renewed and Duplicate Share Certificates",
    chapter: "IV",
    section: "S.46(3) & R.6(3)(a) OF COS (SHARE CAPITAL & DEBENTYRE) RULES, 2014"
  },
  {
    id: 5,
    form: "SH-3",
    register: "Register of Sweat Equity Shares",
    chapter: "IV",
    section: "S.54 & R.8(14) OF COS (SHARE CAPITAL & DEBENTURE) RULES, 2014"
  },
  {
    id: 6,
    form: "SH-6",
    register: "Register of Employee Stock Options",
    chapter: "IV",
    section: "S.62(1)(b) & R.12(10) OF COS (SHARE CAPITAL & DEBENTURES) RULES, 2014"
  },
  {
    id: 7,
    form: "SH-10",
    register: "Register of Shares / Other Securities Bought Back",
    chapter: "IV",
    section: "S.68(9) & R.17(12) OF COS (SHARE CAPITAL & DEBENTURES) RULES, 2014"
  },
  {
    id: 8,
    form: "CHG-7",
    register: "Register of Charges",
    chapter: "VI",
    section: "S.85 & R.10(1) OF COS (REGISTRATION OF CHARGES) RULES, 2014"
  },
  {
    id: 9,
    form: "MBP-2",
    register: "Register of Loans, Guarantees, Securities and Acquisitions made by Company",
    chapter: "XII",
    section: "S.186(9) & R.12(1) OF COS (MEETINGS OF BOARDS & ITS POWERS) RULES, 2014"
  },
  {
    id: 10,
    form: "MBP-3",
    register: "Register of Investments not held in its own name by the Company",
    chapter: "XII",
    section: "S.187(3) & R.14(1) OF COS (MEETINGS OF BOARDS & ITS POWERS) RULES, 2014"
  },
  {
    id: 11,
    form: "MBP-4",
    register: "Register of Contracts with Related Parties and Bodies in which Directors are Interested",
    chapter: "XII",
    section: "S.189(1) & R.16(1) OF COS (MEETINGS OF BOARDS & ITS POWERS) RULES, 2014"
  }
];

       const columns = [

        {
            key: 'id',
            title: 'Sl No.',
            render: (value) => <span className="text-gray-700">{value}</span>
        },
        {
            key: 'form',
            title: 'FORM NAME',
            render: (value) => <span className="text-blue-600">{value}</span>
        },
        {
            key: 'register',
            title: 'NAME OF REGISTER',
            render: (value) => (
                <span className="text-gray-700">
                    {value ? value : '-'}
                </span>
            )
        },
        {
            key: 'chapter',
            title: 'CHAPTER',
            render: (value) => (
                <span className="text-gray-700">
                    {value ? value : '-'}
                </span>
            )
        },
        {
            key: 'section',
            title: 'RELEVANT SECTION & RULE',
            render: (value) => (
                <span className="text-gray-700">
                    {value ? value : '-'}
                </span>
            )
        },
    ];

    const handleEdit = (id) => {
        navigate(`/leads/edit-leads/${id}`);
    };
  return (
    <div>
      <ListDisplayTable
                                        title='	REGISTERS UNDER THE COMPANIES ACT, 2013'
                                        data={tableData}
                                        columns={columns}
                                        // sortable
                                        multiSelect
                                        // onSelect={handleSelection}
                                        // onRowClick={(row) => handleEdit(row.id)}
                                        onRowClick={(row) => navigate(`/register/${row.id}`)}
                                        className="h-full flex flex-col"
                                        headerClassName="bg-gray-100 text-gray-700 sticky top-0 z-10"
                                        rowClassName="hover:bg-gray-50 border-b border-gray-100 cursor-pointer"
                                        cellClassName="p-3 text-sm text-gray-700"
                                        tableClassName="min-w-full divide-y divide-gray-200"
                                        tableWrapperClassName="flex-1 overflow-auto rounded-b-lg"
                                    />
    </div>
  )
}

export default RegistrationFormList
